// Kill switch for the wordlist soft-sell shown after a user's first Learn session.
// Disabled 2026-08-17 to gauge impact on billing; flip back to `true` to reinstate.
export const featureFlags = {
  isLearnWordlistSoftSellEnabled: false,
};
